import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/filters/mutationTypes';

export default {
  [types.SET_TYPE_FILTER]: createSetPropMutation('dataTypeRequested', ''),
  [types.CLEAR_TYPE_FILTER]: createClearPropMutation('dataTypeRequested', ''),
  [types.SET_DATE_FILTER]: createSetPropMutation('dateFilter', ''),
  [types.SET_REPORTS_DATE_FILTER]: createSetPropMutation('reportsDateFilter', ''),
  [types.CLEAR_DATE_FILTER]: createClearPropMutation('dateFilter', ''),
  [types.SET_DOMAIN_FILTER]: createSetPropMutation('domainFilter', []),
  [types.CLEAR_DOMAIN_FILTER]: createClearPropMutation('domainFilter', []),
  [types.SET_ORGANIZATION_FILTER]: createSetPropMutation('organizationFilter', []),
  [types.CLEAR_ORGANIZATION_FILTER]: createClearPropMutation('organizationFilter', []),
};
